import React from "react";
import { MEDIA_GUARD_STYLE, mergeGuardStyle } from "../utils/width-guard";

export interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  src: string;
  title?: string;
  className?: string;
}

/**
 * Iframe component with security attributes and responsive defaults
 * Commonly used for embeds (YouTube, Twitter, Spotify, etc.)
 *
 * Embed markup pasted into an article routinely carries a hard-coded
 * `width="1200"`, which on a phone would widen the article column and the whole
 * page. The inline `max-width: 100%` guard caps it at the column width; authors
 * can still override it via `style`.
 */
export function Iframe({
  src,
  title = "Embedded content",
  className,
  style,
  ...props
}: IframeProps) {
  return (
    <iframe
      src={src}
      title={title}
      className={className}
      style={mergeGuardStyle(MEDIA_GUARD_STYLE, style)}
      loading="lazy"
      allowFullScreen
      {...props}
    />
  );
}
